const initialState = () => ({
  status: 0,
  notification: {}
})

export default initialState
